import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
// import StarRating from "./comp/StarRatting";

// function Test() {
//   const [rating, setRating] = useState(0);
//   return (
//     <div>
//       <StarRating
//         maxRating={5}
//         className="flex items-center"
//         color="red"
//         starContainer="block"
//         size={30}
//         message={["Triable", "Bad", "Okay", "Good", "Excellent"]}
//         defaultRating={3}
//         onsetRating={setRating}
//       />
//       <p>{rating}</p>
//     </div>
//   );
// }

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
    {/* <StarRating maxRating={10} className="flex items-center" /> */}
    {/* <Test /> */}
  </React.StrictMode>
);
